module.exports = __webpack_public_path__ + "static/kenku-654707ba172929208e925c0e7a2eba7a.jpg";